<template>
  <div class="container py-10 ">
    <transition name="fade" mode="out-in">
      <div v-if="submitted" class="text-center py-10">
        <h2>Successfully Submitted</h2>
        <p>Your form has been submitted and will be processed soon.</p>
        <d-btn href="https://awiqcp.org/" style="margin-top: 15px">
          Return Home
        </d-btn>
      </div>
      <div v-else class="flex flex-wrap -mx-5">
        <div class="w-full md:w-5/12 lg:w-4/12 px-5">
          <h1 class="font-bold text-primary-500 text-3xl">
            Close Out a QCP Project
          </h1>
          <p class="mb-5">
            Provide a final contract amount and other information regarding the close-out of a project which specified QCP certification.
          </p>
          <p class="mb-5">
            Simply complete and submit the form here or fax it to us at 571-323-3630.
          </p>
        </div>
        <div class="w-full md:w-7/12 lg:w-8/12 px-5">
          <page-one v-if="currentPage == 1" />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import PageOne from './components/ProjectCloseout/PageOne.vue';


  const { mapGetters, mapActions } = createNamespacedHelpers('projectCloseoutForm');

  export default {
    parent: true,
    components: {
      PageOne,
    },

    computed: {
      ...mapGetters([
        'currentPage',
        'submitted',
      ]),
    },

    mounted() {
      this.getCountries();
    },

    methods: {
      ...mapActions([
        'getCountries',
      ]),
    },
  };
</script>